MOBILE_WIDTH_TRESHOLD = 750;
$(document).ready(function() {

    $('.testimonials-block > .gliders').not('.slick-initialized').slick({
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 900,
        autoplaySpeed: 6000,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: false,
    });

    $('.open-menu-burger-item-children').click(function() {
        var _id = $(this).data('id');
        if($(this).hasClass('opened'))
        {
            $('#menu-burger-item-children-' + _id).slideUp();
            $(this).removeClass('opened');
            $(this).html('<i class="fa-solid fa-chevron-down"></i>');
        }
        else
        {
            $('#menu-burger-item-children-' + _id).slideDown();
            $(this).addClass('opened');
            $(this).html('<i class="fa-solid fa-times"></i>');
        }
    });

    $('.menu-btn').click(function() {
        $('.main-nav').addClass('active');
        $('#menu-main-menu').addClass('active');
    });

    $('.close-menu').click(function() {
        $('.main-nav').removeClass('active');
        $('#menu-main-menu').removeClass('active');
    });

    $('.menu-item-has-children').click(function() {
        $(this).children('.dropdown').toggleClass('active');
        $(this).children('.sub-menu').toggleClass('active');
        $(this).toggleClass('active');
    });

    $('.filter-head').click(function() {
        $(this).toggleClass('active');
        $('.search-bar').toggleClass('active');
        $('.category-filters').toggleClass('active');
    });

    $(window).bind('hashchange', function() {
        var hash = document.location.hash;
        var hash = hash.replace('#', '');

    });
    window.onload = function() {
        var hash = (window.location.hash).replace('#', '');

    }
    if (location.href.indexOf("#") != -1) {
            var hash = window.location.hash.substring(1);
            var hash = hash.replace('#', '');

    }

    if (typeof window.location.search.substr(1) != "undefined") {
        if (window.location.search.substr(1) === "book-a-table") {
            $('#table-book-old').addClass('active');
        }
    }

    $('.close-iframe').click(function() {
        $('.table-book-wrap').removeClass('active');
    });

    $('.close-popup').click(function() {
        $('.popup-wrap').removeClass('enable-popup');
    });

    let lastScrollTop = 0;
    let scrollTop = 0;
    if(!$('body').hasClass('prestige'))
    {
        let SCROLL_THRESHOLD = 30;
        $(window).scroll(function ()
        {
            scrollTop = $(window).scrollTop();

            if (scrollTop < lastScrollTop) {
                $('.page-head').removeClass('scrolled-nav');
            }
            else if (scrollTop >= SCROLL_THRESHOLD) {
                $('.page-head').addClass('scrolled-nav');
            }

            lastScrollTop = scrollTop;
        });
    }
    else
    {
        let SCROLL_THRESHOLD = 90;
        $(window).scroll(function ()
        {
            scrollTop = $(window).scrollTop();

            if (scrollTop < lastScrollTop) {
                $('.page-head').removeClass('scrolled-nav');
            }
            else if (scrollTop >= SCROLL_THRESHOLD) {
                $('.page-head').addClass('scrolled-nav');
            }

            lastScrollTop = scrollTop;
            reveal();
        });
        scrollTop = $(window).scrollTop();

        if (scrollTop < lastScrollTop) {
            $('.page-head').removeClass('scrolled-nav');
        }
        else if (scrollTop >= SCROLL_THRESHOLD) {
            $('.page-head').addClass('scrolled-nav');
        }

        $('.flexible-content-wrap-premium.prestige').children().eq(1).find('.reveal').each((k,v) =>{
            $(v).removeClass('reveal');
        });
        $('.flexible-content-wrap-premium.prestige').children().eq(1).find('.reveal-no-fade').each((k,v) =>{
            $(v).removeClass('reveal-no-fade');
        });

        lastScrollTop = scrollTop;
        reveal();
    }

    $('.hero-book').click(function() {
        $('.hero-popup').addClass('active');
    });

    $('.form-close').click(function() {
        $('.hero-popup').removeClass('active');
    });

    if($('body').hasClass('premium')) {
        if(!$('body').hasClass('prestige')) {
            checkTop();
        }

        $('.faqs .list-element').click(function(e){
            $(this).toggleClass('open');
        });

        $('.book-bar input[type="text"]').each(function(k,v){
            $(v).datepicker({ dateFormat: 'dd/mm/yy' });
        });

        if($('.book-bar form').length){

            $('.book-bar form').each(function(){
                $(this).submit(function(e){

                    if($(this).find('input[name="dateFrom"]').val() && $(this).find('input[name="dateTo"]').val()){

                        var arrival = convertUKDateStringToUSDateString($(this).find('input[name="dateFrom"]').val())
                        var departure = convertUKDateStringToUSDateString($(this).find('input[name="dateTo"]').val())
                        var date1 = new Date(arrival);
                        var date2 = new Date(departure);

                        // To calculate the time difference of two dates
                        var Difference_In_Time = date2.getTime() - date1.getTime();

                        // To calculate the no. of days between two dates
                        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

                        $(this).find('input[name="numNights"]').val(Difference_In_Days);

                    } else {
                        $(this).append('<div class="alert alert--error">Please enter dates in the format dd/mm/yyyy</div>');
                        e.preventDefault();
                    }
                });
            });
        }

        if($('.vimeo').length > 0){
            checkVimeo();
        }
    }

    $('button[name="add-to-cart"]').on('click', function(){
        fbq('track', 'AddToCart');
    });

    $('a.checkout-button').on('click', function(){
        fbq('track', 'InitiateCheckout');
    });

    $('.mobile-carousel').each((k, v) => {
        $(v).slick({
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            cssEase: 'linear',
            speed: 2000,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: false,
            fade: true
        });
    });

    /** JS for Generic Pager - Start **/
    $('.pager-container > .pager-select').change(function() {
        var _slug = $(this).data('slug');
        var _page = $(this).val();
        location.href = '/' + _slug + '/page/' + _page;
    });

    $('.pager-container > .pager-start').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        location.href = '/' + _slug ;
    });

    $('.pager-container > .pager-prev').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page--;
        location.href = '/' + _slug + '/page/' + _page;
    });

    $('.pager-container > .pager-next').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page++;
        location.href = '/' + _slug + '/page/' + _page;
    });

    $('.pager-container > .pager-end').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').data('maxpage');
        location.href = '/' + _slug + '/page/' + _page;
    });
    /** JS for Generic Pager - End **/

    initBlogFilterEvents();
    adairEventHandlers();
});

function adairEventHandlers(){
    /** JS for Partner Cards - start **/
    if($('.partner-cards').length)
    {
        const slides = $('.partner-cards > .mobile-view');
        $(slides).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            speed: 300
        });
    }
    /** JS for Partner Cards - end **/

    /** JS for Join Event Button - start **/
    $('a.join').on('click', (e) =>{
        e.preventDefault();
        $('#popup_bkg').show();
        $('#join_popup_wrapper').css('display', 'flex');
        let el = e.target;
        let val = $(el).data('id');
        $('#event_id_field').val(val);
    });

    $('.close_popup').on('click', ()=>{
        $('#join_popup_wrapper').hide();
        $('#popup_bkg').hide();
    });

    document.getElementById('join_event_form').addEventListener('submit',(e) => {
        e.preventDefault();
        const myFormData = new FormData(e.target);

        const formDataObj = {};
        myFormData.forEach((value, key) => (formDataObj[key] = value));

        formDataObj['action'] = 'join_event';

        jQuery.ajax({
            type: 'post',
            url : wired.ajaxurl,
            data : formDataObj,
            success: function(response) {
                if(response.success){
                    $('#join_event_form').hide();
                    $('#join_popup p.success').show();
                    window.setTimeout(() => {
                        $('.close_popup').trigger('click');
                    }, 5000);
                }else{
                    alert("an error occurred, please try later");
                }
            }
        })
    });
    /** JS for Join Event Button - end **/

    /** script to align heading, excerpt content in blocks **/
    blocksSameHeight();
}

$(window).resize(function(){
    blocksSameHeight();
});

(function() {
    window.dispatchEvent(new Event('resize'));
})();

function blocksSameHeight(){
    /** script to align heading, excerpt content in blocks - start **/
    var _block_names = [];
    _block_names.push('clubs-main-page');
    _block_names.push('clubs-title-block');
    _block_names.push('events-main-page');
    _block_names.push('events-title-block');
    _block_names.push('tiles');

    $.each(_block_names, function( index, value ) {
        $('.' + value).each(function(){
            var _height_heading = 40;
            var _height_excerpt = 120;
            var _this = this;
            var cardwrapper = $(_this).find('.card-wrapper');
            if(cardwrapper.length){
                cardwrapper.find('.tile-heading').sameHeight();
                cardwrapper.find('.content').sameHeight();
            }

            // $(_this).find('.card-wrapper').each(function(){
            //     if($(this).find('.tile-heading').height()){
            //         _height_heading = $(this).find('.tile-heading').height();
            //     }
            //     if($(this).find('.content').height()){
            //         _height_excerpt = $(this).find('.content').height();
            //     }
            // });

            // $(_this).find('.card-wrapper').each(function(){
            //     $(this).find('.tile-heading').height(_height_heading);
            //     $(this).find('.content').height(_height_excerpt);
            // });
        });
    });
}

function initBlogFilterEvents(){
    /** JS for Blog Pager - Start **/
    $('.pager-container > .pager-select').unbind('change');
    $('.pager-container > .pager-select').change(function() {
        var _slug = $(this).data('slug');
        var _page = $(this).val();
        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });

    $('.pager-container > .pager-start').unbind('change');
    $('.pager-container > .pager-start').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        location.href = '/' + _slug  + getBlogFiltersParams();
    });

    $('.pager-container > .pager-prev').unbind('change');
    $('.pager-container > .pager-prev').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page--;
        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });

    $('.pager-container > .pager-next').unbind('change');
    $('.pager-container > .pager-next').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page++;
        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });

    $('.pager-container > .pager-end').unbind('change');
    $('.pager-container > .pager-end').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').data('maxpage');
        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });
    /** JS for Blog Pager - End **/

    $('#filter_search').unbind('keyup');
    $('#filter_search').keyup(function(e){
        if(e.which == 13){
            var _slug = $('.pager-container > .pager-select').data('slug');
            var _page = $('.pager-container > .pager-select').val();

            location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
        }
    });

    $('.blog_filter_button').unbind('click');
    $('.blog_filter_button').click(function(){
        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();

        if(_slug == undefined || _page == undefined){
            return false;
        }

        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });

    $('.filter_box_toggle').unbind('click');
    $('.filter_box_toggle').click(function(){
        if($(this).hasClass('caret-up')){
            $('.filter_box_toggle').each(function(){
                $(this).removeClass('caret-up').addClass('caret-down');
            });

            $('.filter_hidden').each(function(){
                $(this).slideDown();
            });
        }
        else{
            $('.filter_box_toggle').each(function(){
                $(this).removeClass('caret-down').addClass('caret-up');
            });

            $('.filter_hidden').each(function(){
                $(this).slideUp();
            });
        }
        setTimeout(function(){
            initBlogFilterEvents();
        }, 1000);
    });
}

function getBlogFiltersParams(){
    var _filters = "";
    var _filters_array = [];

    if($('#filter_search').val() != "")
        _filters_array.push('search=' + $('#filter_search').val());

    var _selected_categories = [];
    $('.filter_category').each(function(){
        if($(this).is(':checked')){
            _selected_categories.push($(this).val());
        }
    });
    if(_selected_categories.length > 0)
        _filters_array.push('cat_ids=' + _selected_categories.join(','));

    var _selected_years = [];
    $('.filter_year').each(function(){
        if($(this).is(':checked')){
            _selected_years.push($(this).val());
        }
    });
    if(_selected_years.length > 0)
        _filters_array.push('years=' + _selected_years.join(','));

    var _selected_months = [];
    $('.filter_month').each(function(){
        if($(this).is(':checked')){
            _selected_months.push($(this).val());
        }
    });
    if(_selected_months.length > 0)
        _filters_array.push('months=' + _selected_months.join(','));

    if(_filters_array.length > 0)
        _filters = "?" + _filters_array.join("&");
    return _filters;
}

var _featured_venues_conflict_prevention = false;
function initMultiSelectDropdown(_id, _label){
    $(_id).multiSelect({

        // Custom templates
        'containerHTML': '<div class="multi-select-container">',
        'menuHTML': '<div class="multi-select-menu">',
        'buttonHTML': '<span class="multi-select-button">',
        'menuItemsHTML': '<div class="multi-select-menuitems">',
        'menuItemHTML': '<label class="multi-select-menuitem">',
        'presetsHTML': '<div class="multi-select-presets">',

        // sets some HTML (eg: <div class="multi-select-modal">) to enable the modal overlay.
        'modalHTML': undefined,

        // Active CSS class
        'activeClass': 'multi-select-container--open',

        // Text to show when no option is selected
        'noneText': _label,

        // Text to show when all options are selected
        'allText': undefined,

        // an array of preset option groups
        // presets: [{
        //   name: 'All categories',
        //   all: true // select all
        // },{
        //   name: 'My categories',
        //   options: ['a', 'c']
        // }]
        'presets': undefined,

        // CSS class added to the container, when the menu is about to extend beyond the right edge of the position<a href="https://www.jqueryscript.net/menu/">Menu</a>Within element
        'positionedMenuClass': 'multi-select-container--positioned',

        // If you provide a jQuery object here, the plugin will add a class (see positionedMenuClass option) to the container when the right edge of the dropdown menu is about to extend outside the specified element, giving you the opportunity to use CSS to prevent the menu extending, for example, by allowing the option labels to wrap onto multiple lines.
        'positionMenuWithin': undefined,

        // The plugin will attempt to keep this distance, in pixels, clear between the bottom of the menu and the bottom of the viewport, by setting a fixed height style if the menu would otherwise approach this distance from the bottom edge of the viewport.
        'viewportBottomGutter': 20,

        // minimal height
        'menuMinHeight': 200

      });
}

function checkMobileHeights(){
    let myResizeCallback = function(){
        $('.mobile_check_height').each((k, v) => {
            let card = $(v).find('.card-wrapper-prestige');
            let H = $(card).outerHeight();
            let top = parseInt($(card).css('top'));
            let tot = H + top;
            $(v).height(tot);
        });
        reveal();
    };
    if(window.innerWidth < MOBILE_WIDTH_TRESHOLD) {
        setTimeout(myResizeCallback, 2000);
    }else{
        document.querySelectorAll('.mobile_check_height').forEach((v) => {
            v.style.removeProperty('height');
        });
    }
}

$(window).resize(function() {
    if(!$('body').hasClass('prestige')) {
        checkTop();
    }

//    fixGalleryTabs();
    if($('.vimeo').length > 0){
        checkVimeo();
    }
    checkMobileHeights();
});

function checkVimeo(){
    var ratio = $('.vimeo').parent().data('ratio');
    var wrapper = $('.vimeo').parent().parent();
    var W = $(wrapper).width();
    var estH = Math.round(W * (1/ratio));
    $(wrapper).height(estH);
}

function fixGalleryTabs(){
    $('.gallery-block .slick-dots').children().gt(4).each(function(k,v){
        $(v).remove();
    });
}

function checkTop(){
    var H = Math.floor($('header.page-head').outerHeight() - 1);
    $('.flexible-content-wrap-premium').css('paddingTop', H+'px');

    var W = $(window).width();
    var calc;
    if(W <= 750){
        calc = 'calc(50vh - '+H+'px)';
    }else{
        calc = 'calc(100vh - '+H+'px)';
    }
    $('.hero-block-wrapper img').css('height', calc);
    $('.hero-block-wrapper .videowrapper').css('height', calc);
    $('.hero-block-wrapper .videoplayer').css('height', calc);
    $('.hero-block-wrapper .overlay-wrapper').css('height', calc);

}

function convertUKDateStringToUSDateString(date){

    var dateParts = date.split("/");

    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

    return dateObject.toString();
}

if($('.hero-book').length > 0) {
    var fixmeTop = $('.hero-book').offset().top - $("header.page-head").height(); // get initial position of the element
    $(window).scroll(function () {
        var currentScroll = $(window).scrollTop();

        if (currentScroll >= fixmeTop) {
            $('.hero-book').css({
                position: 'fixed',
                bottom: '0',
                top: 'auto'

            });
        } else {
            $('.hero-book').removeAttr("style");
        }

    });
}

function showMenu() {
    $('.menu-overlay').addClass('active');
    $('.menu-btn-close').addClass('active');
}
function hideMenu() {
    $('.menu-overlay').removeClass('active');
    $('.menu-btn-close').removeClass('active');
}

function scrollNext(el, _parent_class){
    let curRef = $(el).data('ref');
    if(typeof curRef === 'undefined'){
        let dest = $(el).closest(_parent_class).next();
        let curID = $(dest).attr('id');
        if(typeof curID === 'undefined'){
            dest = $(el).next(_parent_class).next();
            curID = $(dest).attr('id');
        }
        if(typeof curID === 'undefined'){
            dest = $(_parent_class).next();
            curID = $(dest).attr('id');
        }
        if(typeof curID === 'undefined'){
            let newId = "id-"+Math.floor(Math.random() * 999);
            $(dest).attr('id', newId);
            curRef = '#'+newId;
            $(el).data('ref', curRef);
        }
        else{
            curRef = '#'+curID;
            $(el).data('ref', curRef);
        }
    }
    $('html, body').animate({
        scrollTop: $(curRef).offset().top
    }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = curRef;
    });
}

function reveal() {
    var reveals = document.querySelectorAll(".reveal");
    for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 50;
        if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
        } else {
            reveals[i].classList.remove("active");
        }
    }

    reveals = document.querySelectorAll(".reveal-no-fade");
    for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 50;
        if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
        } else {
            reveals[i].classList.remove("active");
        }
    }
}